import { render, staticRenderFns } from "./DiscoveryTableList.vue?vue&type=template&id=1f8b44bc&scoped=true&"
import script from "./DiscoveryTableList.vue?vue&type=script&lang=js&"
export * from "./DiscoveryTableList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8b44bc",
  null
  
)

export default component.exports